import DisputeService from "../../service/DisputeService";
// import swal from 'sweetalert'

export const namespaced = true

export const state = {
    disputeLoading: true,
    createLoading: false,
    disputes:[],
    disputesAdmin:[],
    response: {},
    querySession:{},
    logs:[]
}


export const getters = {
}


export const mutations = {
    updateDisputes: (state, payload) =>{
      state.disputes = payload
    },
    updateDisputeAdmin: (state, payload) =>{
      state.disputesAdmin = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
    updateDisputeLoading: (state, payload) =>{
        //console.log('Entered Mutation updateDisputeLoading', payload);
        state.disputeLoading = payload;
    },
    updateCreateLoading: (state, payload) =>{
        //console.log('Entered Mutation updateDisputeLoading', payload);
        state.createLoading = payload;
    },
    querySessionId: (state, payload) =>{
        state.querySession = payload;
        state.logs = [];
        let i = 0;
        for (let key in state.querySession) {
            state.logs[i] = {
                "key":key,
                "value":state.querySession[key]
            };
            i++
        }
        //console.log('Entered Mutation querySessionId >>>> ', state.querySession, payload);
    },
    reset: (state, payload) =>{
        state.DisputeLoading = payload;
        state.response ={};
    },

}

export const actions = {
    updateDisputes: ({ commit }, payload)=>{
        // console.log("updateDispute>>>>>>")
        // commit("updateDisputeLoading", true)
        return DisputeService.callReadDisputesApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDisputeLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateDisputes", responseData.data)
                }

            })
            .catch(error => {
                commit("updateDisputeLoading", false)
                alert(error)
                // throw error;
            });
    },

    updateDisputeAdmin: ({ commit }, payload)=>{
        // console.log("updateDisputeAdmin>>>>>>")
        // commit("updateDisputeLoading", true)
        // let dialogs = payload.dialogs;
        // delete payload.dialogs;
        return DisputeService.callReadDisputesAdminApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDisputeLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateDisputeAdmin", responseData.data)
                }else{

                    // swal({
                    //     title: `Error!`,
                    //     text: response.data.responseMessage,
                    //     buttonsStyling: false,
                    //     confirmButtonClass: 'btn btn-success btn-fill',
                    //     type: 'error'
                    // });
                }

            })
            .catch(error => {
                commit("updateDisputeLoading", false)
                alert(error)
                // throw error;
            });
    },

    querySessionId: ({ commit }, payload)=>{
        // console.log("updateDisputeAdmin>>>>>>")
        commit("updateDisputeLoading", true)
        return DisputeService.callQuerySessionIdApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDisputeLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("querySessionId", responseData)
                }else{
                    commit("updateDisputeLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    //console.log("source>>>>>",responseData)
                    commit("querySessionId", responseData)
                }

            })
            .catch(error => {
                commit("updateDisputeLoading", false)
                alert(error)
                // throw error;
            });
    },

    createDispute: ({ commit }, payload)=>{
        // console.log("updateDispute>>>>>>")
        commit("updateCreateLoading", true)
        commit("updateResponse", {})
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        return DisputeService.callCreateDisputeApi(payload)
            .then(response => {
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateCreateLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    commit("updateCreateLoading", false)
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }

            })
            .catch(error => {
                commit("updateCreateLoading", false)
                alert(error)
                // throw error;
            });
    },

    editDispute: ({ commit }, payload)=>{
        commit("updateCreateLoading", true)
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        return DisputeService.callUpdateDisputeApi(payload)
            .then(response => {
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateCreateLoading", false)
                    commit("updateIsAccountsUpt", true)
                    // console.log("callupdateAccountsApi responseData ==>>", responseData);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Account upgrade successfully!', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
            })
            .catch(error => {
                commit("updateCreateLoading", false)
                alert(error)
            });
    },

    editDisputeStatus: ({ commit }, payload)=>{
        commit("updateCreateLoading", true)
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        return DisputeService.callUpdateStatusDisputeApi(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateCreateLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateIsAccountsUpt", true)
                    // //console.log("callupdateAccountsApi responseData ==>>", responseData);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
            })
            .catch(error => {
                commit("updateCreateLoading", false)
                alert(error)
            });
    },

    reOpenDispute: ({ commit }, payload)=>{
        commit("updateCreateLoading", true)
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        return DisputeService.callReOpenDisputeApi(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateCreateLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateIsAccountsUpt", true)
                    // console.log("callupdateAccountsApi responseData ==>>", responseData);
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
            })
            .catch(error => {
                commit("updateCreateLoading", false)
                alert(error)
            });
    },

    updateIsDisputeUpt: ({ commit }, payload)=>{
        commit('updateIsDisputeUpt', payload)
    },
    updateIsDisputeAdminUpt: ({ commit }, payload)=>{
        commit('updateIsDisputeUpt', payload)
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }

}
